import React from 'react';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { Col, Typography } from 'antd';
import { ContentIncidentForm } from './styles';
import MobileForm from '../../../components/mobileForm/MobileForm';

const ContentMobileForm = ({ mobileForm }) => {
  const pages = mobileForm?.form?.dataForm ?? [];

  return (
    <>
      {pages?.map((page, index) => {
        const key = page?._id;
        const label = page?.label || '';
        const fieldsList = page?.list ?? [];
        const formErrors = mobileForm?.errors?.formErrors?.[index]?.errors ?? [];

        return (
          <>
            <section key={key} style={{ marginBottom: 24 }}>
              {label ? (
                <ContentIncidentForm align="middle">
                  <Col md={1}>
                    <FeatherIcon icon="file-text" className="iconTitle" style={{ color: '#8D8E90' }} size={22} />
                  </Col>

                  <Col md={22}>
                    <Typography.Title level={5} className="title" style={{ margin: 0, color: '#8D8E90' }}>
                      {label}
                    </Typography.Title>
                  </Col>
                </ContentIncidentForm>
              ) : null}

              <MobileForm
                fields={fieldsList}
                formValues={mobileForm.values.mobileFormValues}
                onChange={mobileForm.values.updateFieldValue}
                fieldsErrors={formErrors}
              />
            </section>
          </>
        );
      })}
    </>
  );
};

export default ContentMobileForm;

ContentMobileForm.propTypes = {
  mobileForm: PropTypes.object,
};
